import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.QBooksWorkflowDetails', {
    endStepBubbleTextPo: 'Creation in QuickBooks',
    endStepDescriptionPo:
        '{pluralTemplateName} will be automatically created in QuickBooks Online upon final approval.',
});
